var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlans = function SvgPlans(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "planes",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 13",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_752_332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2.5H2.5C1.94772 2.5 1.5 2.94772 1.5 3.5V10.5C1.5 11.0523 1.94772 11.5 2.5 11.5H9.5C10.0523 11.5 10.5 11.0523 10.5 10.5V3.5C10.5 2.94772 10.0523 2.5 9.5 2.5Z",
    fill: "#2E3744",
    stroke: "#2E3744",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5V3.5",
    stroke: "#FAFAFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 1.5V3.5",
    stroke: "#FAFAFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5V3.5",
    stroke: "#2E3744",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 1.5V3.5",
    stroke: "#2E3744",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.99854,
    y: 5.98975,
    width: 2.00146,
    height: 2.00684,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.99927,
    y: 5.98975,
    width: 2.00146,
    height: 2.00684,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 5.98975,
    width: 2.00146,
    height: 2.00684,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8.94849H10.0015V10.4553C10.0015 10.7315 9.77761 10.9553 9.50146 10.9553H8V8.94849Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.99878 8.94849H4.00024V10.9553H2.49878C2.22264 10.9553 1.99878 10.7315 1.99878 10.4553V8.94849Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.99927,
    y: 8.94849,
    width: 2.00146,
    height: 2.00684,
    fill: "#FAFAFA"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlans);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "plans.2e4a5c7889bc88f93a0153d5bca981f6.svg";